import React from "react"
import { Routes, Route } from "react-router-dom"

import MainLayout from "../layouts/MainLayout"

import Home from "../pages/Home"
import Services from "../pages/Services"
import MassageServices from "../pages/MassageServices"
import FacialServices from "../pages/FacialServices"
import BeautyServices from "../pages/BeautyServices"
import RitualServices from "../pages/RitualServices"
import WellnessFacilities from "../pages/WellnessFacilities"
import Gallery from "../pages/Gallery"
import About from "../pages/About"
import Contact from "../pages/Contact"
import PrivacyPolicy from "../pages/PrivacyPolicy"
import TermsConditions from "../pages/TermsConditions"
import NotFound from "../pages/NotFound"

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        {/* Pages */}
        <Route index element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/massages" element={<MassageServices />} />
        <Route path="/services/soins-visage" element={<FacialServices />} />
        <Route path="/services/beaute" element={<BeautyServices />} />
        <Route path="/services/rituels" element={<RitualServices />} />
        <Route path="/services/installations" element={<WellnessFacilities />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
<Route
  path="/politique-confidentialite"
  element={<PrivacyPolicy />}
/>

<Route
  path="/conditions-generales"
  element={<TermsConditions />}
/>
        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}